import { SET_REFRESH_TOKEN_FAILED } from './actionTypes';

export const setRefreshTokenFailed = (name) => (dispatch) =>
	dispatch({
		type: SET_REFRESH_TOKEN_FAILED,
		payload: name,
	});
